export interface Response {
  success: boolean;
  error: any;
  message: string;
  result: any;
  data: any;
  request_id: number;
}
